import { useTranslation } from '../../../i18n/i18n';
import HostedMobileLayout from '../../../layouts/MobileLayout';
import HostedActionRow from '../../../components/hosted/ActionRow';
import HostedFaqModal from '../../../components/hosted/FaqModal';
import { useFaqModal } from '../../../hooks/useFaqModal';
import HostedNeedHelpSection from '../../../components/hosted/NeedHelpSection';
import HostedAppPickerScreen from '../shared/AppPickerScreen';
import { type AppPickerPageProps } from '../../types';

export default function HostedMobileAppPickerPage({
  tokens,
  handlerApps,
  recommendedHandlerAppUuids,
  onSelect,
  onCancel,
}: AppPickerPageProps) {
  const { t } = useTranslation();
  const faq = useFaqModal();

  return (
    <HostedMobileLayout
      footer={
        <HostedActionRow
          secondary={{ label: t('agentStart.cancel'), onClick: onCancel }}
        />
      }
    >
      <div>
        <h2
          data-testid="app-picker-title"
          className="text-xl font-semibold text-foreground text-center"
        >
          {t('appPicker.title')}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground text-center">
          {t('appPicker.subtitle')}
        </p>
      </div>

      <HostedAppPickerScreen
        className="max-h-[calc(50vh+5rem)]"
        tokens={tokens}
        handlerApps={handlerApps}
        recommendedHandlerAppUuids={recommendedHandlerAppUuids}
        onSelect={onSelect}
      />

      <HostedNeedHelpSection
        topics={['whatAreWallets', 'whyNotSupported']}
        onSelectTopic={faq.open}
      />
      <HostedFaqModal {...faq.modal} />
    </HostedMobileLayout>
  );
}
